import { DayOfWeek, ClassSchedule } from 'app/javascript/types';

export const DISPLAY_DAY_ORDER: DayOfWeek[] = [1, 2, 3, 4, 5, 6, 0];

export const DAY_LABELS: Record<DayOfWeek, string> = {
  0: 'Domingo',
  1: 'Segunda-feira',
  2: 'Terça-feira',
  3: 'Quarta-feira',
  4: 'Quinta-feira',
  5: 'Sexta-feira',
  6: 'Sábado',
};

export const DAY_SHORT_LABELS: Record<DayOfWeek, string> = {
  0: 'Dom',
  1: 'Seg',
  2: 'Ter',
  3: 'Qua',
  4: 'Qui',
  5: 'Sex',
  6: 'Sáb',
};

export function groupByDay(schedules: ClassSchedule[]): Map<DayOfWeek, ClassSchedule[]> {
  const grouped = new Map<DayOfWeek, ClassSchedule[]>();
  for (const day of DISPLAY_DAY_ORDER) {
    const daySchedules = schedules.filter((s) => s.day_of_week === day);
    if (daySchedules.length > 0) {
      grouped.set(day, daySchedules);
    }
  }
  return grouped;
}

export function getCurrentDayOfWeek(): DayOfWeek {
  return new Date().getDay() as DayOfWeek;
}

export function trimEmptyEdges(days: DayOfWeek[], schedules: ClassSchedule[]): DayOfWeek[] {
  const daysWithClasses = new Set(schedules.map((s) => s.day_of_week));

  let start = 0;
  while (start < days.length && !daysWithClasses.has(days[start])) start++;

  let end = days.length - 1;
  while (end >= start && !daysWithClasses.has(days[end])) end--;

  return days.slice(start, end + 1);
}


function timeToMinutes(time: string): number {
  const [h, m] = time.split(':').map(Number);
  return h * 60 + m;
}

export interface ScheduleHighlight {
  activeIds: number[];
  nextUpcomingId: number | null;
}

export function getHighlightedScheduleIds(
  schedules: ClassSchedule[],
  now: Date = new Date()
): ScheduleHighlight {
  const currentDay = now.getDay() as DayOfWeek;
  const currentMinutes = now.getHours() * 60 + now.getMinutes();

  const todaySchedules = schedules
    .filter((s) => s.day_of_week === currentDay)
    .sort((a, b) => timeToMinutes(a.start_time) - timeToMinutes(b.start_time));

  const activeIds = todaySchedules
    .filter((s) => {
      const start = timeToMinutes(s.start_time);
      const end = timeToMinutes(s.end_time);
      return (start - 30) <= currentMinutes && currentMinutes < end;
    })
    .map((s) => s.id);

  if (activeIds.length > 0) {
    return { activeIds, nextUpcomingId: null };
  }

  const nextSchedule = todaySchedules.find(
    (s) => timeToMinutes(s.start_time) > currentMinutes
  );

  return { activeIds: [], nextUpcomingId: nextSchedule?.id ?? null };
}
